module.exports = __webpack_public_path__ + "img/03.9f7d2507.png";